import React from "react";
import { useEffect, useState } from "react";
import {
  getDeliveryCostDataAPI,
  UpdateDeliverCostAPI,
} from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import DeliverCostTabel from "../../Tables/Deliver/DeliverCostTabel/DeliverCostTabel";
import Style from "./DeliverCostContainer.module.scss";
const DeliverCostContainer = () => {
  const [costDataState, setConstDataState] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    getDeliveryCostData();
  }, []);
  const getDeliveryCostData = async () => {
    getDeliveryCostDataAPI((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setConstDataState(res.delivery);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    });
  };
  const UpdateCostHandler = (key, CostFactor) => {
    for (let index = 0; index < Object.keys(CostFactor).length; index++) {
      setLoadingPage(true);
      let info = {
        month: Object.keys(CostFactor)[index],
        hour: key,
        value: CostFactor[Object.keys(CostFactor)[0]],
      };
      UpdateDeliverCostAPI(info, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);
          getDeliveryCostData();
          setLoadingPage(false);

        } else {
          errorToast(succ.message);
        }
      });
    }
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ویرایش ضریب هزینه پیک"} />
      <DeliverCostTabel
        UpdateData={UpdateCostHandler}
        costData={costDataState}
        loadingPage={loadingPage}
      />
    </div>
  );
};

export default DeliverCostContainer;
